import * as permissions from '@/common/permissionConstants';
import { useAuthStore } from '@/stores/auth';

export default [
    {
        path: 'settings',
        name: 'settings',
        redirect: () => {
            const authStore = useAuthStore();
            if (authStore.isBnSupport) {
                return { name: 'account' };
            }
            return { name: 'me' };
        },
        component: () => import('../views/SettingsPage.vue'),
        children: [
            {
                path: 'me',
                name: 'me',
                meta: { label: 'My settings' },
                component: () => import('../views/settings/MePage.vue'),
                props: true,
            },
            {
                path: 'account',
                name: 'account',
                meta: { label: 'Account details', hasPermission: permissions.MANAGE_ACCOUNT },
                props: true,
                component: () => import('../views/settings/AccountPage.vue'),
            },
            {
                path: 'security-permission-groups',
                name: 'security-permission-groups',
                meta: { label: 'Security - Permission groups', hasPermission: permissions.MANAGE_ROLES },
                component: () => import('../views/settings/SecurityPermissionGroupsPage.vue'),
            },
            {
                path: 'security-access-groups',
                name: 'security-access-groups',
                meta: { label: 'Security - Access groups', hasPermission: permissions.MANAGE_ROLES },
                component: () => import('../views/settings/SecurityAccessGroupsPage.vue'),
            },
            {
                path: 'patient-portal',
                name: 'patient-portal',
                meta: { label: 'Patient portal', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/PatientPortalPage.vue'),
                props: true,
            },
            {
                path: 'users',
                name: 'users',
                meta: { label: 'Users', hasPermission: permissions.MANAGE_USERS },
                component: () => import('../views/settings/UsersPage.vue'),
            },
            {
                path: 'form-manager',
                name: 'form-manager',
                meta: { label: 'Form manager', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/FormManagerPage.vue'),
            },
            {
                path: 'form-packet-manager',
                name: 'form-packet-manager',
                meta: { label: 'Form packet manager', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/FormPacketManagerPage.vue'),
            },
            {
                path: 'live-form-manager',
                name: 'live-form-manager',
                meta: { label: 'Live forms', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/FormManagerPage.vue'),
            },
            {
                path: 'autonote-manager',
                name: 'autonote-manager',
                meta: { label: 'AutoNotes', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/AutonoteManagerPage.vue'),
            },
            {
                path: 'appointment-reminders',
                name: 'appointment-reminders',
                meta: { label: 'Appt. Reminders', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/AppointmentRemindersPage.vue'),
            },
            {
                path: 'api-access',
                name: 'api-access',
                meta: { label: 'API access', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/ApiAccessPage.vue'),
            },
            {
                path: 'integrations',
                name: 'integrations',
                meta: { label: 'Integrations', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/IntegrationsPage.vue'),
                devOnly: true,
            },
            {
                path: 'integrations/labs',
                name: 'integrations-labs',
                meta: { label: 'Lab connections', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/LabConnectionsPage.vue'),
                devOnly: true,
            },
            {
                path: 'integrations/labs/users',
                name: 'integrations-labs-users',
                meta: { label: 'Lab users', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/LabUsersPage.vue'),
                devOnly: true,
            },
            {
                path: 'appointment-types',
                name: 'appointment-types',
                meta: { label: 'Appointment types', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/EncounterTypesPage.vue'),
            },
            {
                path: 'care-team-departments',
                name: 'care-team-departments',
                meta: { label: 'Departments', hasPermission: permissions.MANAGE_CARE_TEAM_DEPARTMENTS },
                component: () => import('../views/settings/CareTeamDepartmentsPage.vue'),
            },
            {
                path: 'patient-risk-flags',
                name: 'patient-risk-flags',
                meta: { label: 'Patient risk flags', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/PatientRiskFlagsPage.vue'),
            },
            {
                path: 'payers',
                name: 'payers',
                meta: { label: 'Payers', hasPermission: permissions.MANAGE_HEALTH_CARE_SERVICES },
                component: () => import('../views/settings/PayersPage.vue'),
            },
            {
                path: 'healthcare-services',
                name: 'healthcare-services',
                meta: { label: 'Health care services', hasPermission: permissions.MANAGE_HEALTH_CARE_SERVICES },
                component: () => import('../views/settings/HealthcareServicesPage.vue'),
            },
            {
                path: 'locations',
                name: 'locations',
                meta: { label: 'Locations', hasPermission: permissions.MANAGE_ACCOUNT },
                component: () => import('../views/settings/LocationsPage.vue'),
            },
            {
                path: 'programs',
                name: 'programs',
                meta: { label: 'Programs', hasPermission: permissions.MANAGE_PROGRAMS },
                component: () => import('../views/settings/ProgramsPage.vue'),
            },
            {
                path: 'ebtx-library',
                name: 'ebtx-library',
                meta: { label: 'EBTx Library', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/EBTxLibraryPage.vue'),
            },
            {
                path: 'ebtx-library/:categoryId',
                name: 'ebtx-library-category',
                meta: { label: 'EBTx Library', hasPermission: [permissions.MANAGE_TEMPLATES] },
                component: () => import('../views/settings/EBTxLibraryCategoryPage.vue'),
                props: true,
            },
        ],
    },
];
